module.exports = "https://r.nearpod.com/assets/media/image/settings_icon-ccd791b0d41f724c4e30733f4105129a.svg";